import { useMappedConstants } from "@/app/hooks/useMappedConstants";
import clsx from "clsx";

const PetStatus: React.FC<{ petStatus: string; className?: string }> = ({ petStatus, className }) => {
  const { petStatusColors } = useMappedConstants();
  return <span className={clsx(petStatusColors[petStatus?.toLowerCase()], className)}>{petStatus}</span>;
};

export default PetStatus;
